import { useState, useMemo } from 'react';
import { Category, StockItem } from '../types';
import { SAMPLE_CATEGORIES, SAMPLE_STOCK_ITEMS } from '../constants/sampleData';

export const useStockData = (searchQuery: string, currentPage: number, itemsPerPage: number) => {
    const [categories] = useState<Category[]>(SAMPLE_CATEGORIES);
    const [stockItems] = useState<StockItem[]>(SAMPLE_STOCK_ITEMS);

    // Filter data based on search
    const filteredCategories = useMemo(() => {
        return categories.filter(category =>
            category.name.toLowerCase().includes(searchQuery.toLowerCase())
        );
    }, [categories, searchQuery]);

    const filteredItems = useMemo(() => {
        return stockItems.filter(item =>
            item.category.toLowerCase().includes(searchQuery.toLowerCase()) ||
            item.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
            (item.itemCode && item.itemCode.toLowerCase().includes(searchQuery.toLowerCase()))
        );
    }, [stockItems, searchQuery]);

    // Pagination logic for categories
    const totalCategoriesPages = Math.ceil(filteredCategories.length / itemsPerPage);
    const paginatedCategories = useMemo(() => {
        return filteredCategories.slice(
            (currentPage - 1) * itemsPerPage,
            currentPage * itemsPerPage
        );
    }, [filteredCategories, currentPage, itemsPerPage]);

    // Pagination logic for items
    const totalItemsPages = Math.ceil(filteredItems.length / itemsPerPage);
    const paginatedItems = useMemo(() => {
        return filteredItems.slice(
            (currentPage - 1) * itemsPerPage,
            currentPage * itemsPerPage
        );
    }, [filteredItems, currentPage, itemsPerPage]);

    return {
        categories: paginatedCategories,
        stockItems: paginatedItems,
        totalCategories: filteredCategories.length,
        totalItems: filteredItems.length,
        totalCategoriesPages,
        totalItemsPages,
    };
};